export default __webpack_public_path__ + "static/media/icon-harmony-fairmined2.64d264b5.svg";